import { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { closeDialog } from '../../store/modules/dialog';
import Dialog from './Dialog';
import IconSpinner from '../../img/spinner.gif';
import IconCheck from '../../img/check.gif';
import IconFail from '../../img/ico_error.png';
import { updateNaverWorksFile } from '../../extApis/naverWorksApi';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { setFileName, useDocInfoSliceSelector } from '../../store/modules/docInfo';
import { useEffect } from 'react';
import { NAVERWORKS_ROOT_FOLDER_NAME } from '../../define/naverworksDefine';
import { setNaverWorksFileInfo } from '../../store/modules/naverWorksData';
import { useTranslation } from 'react-i18next';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../../context/indexedDBContext';
import ga from '../../utils/gaConnect';
import { DOCUMENT_TYPE, DOC_FORMAT_CONFIG_VALUES } from '../../define/global';

const DialogBody = styled.div`
  display: flex;
  width: 300px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;

export const DownloadStateIcon = styled.img`
  width: 64px;
  height: 64px;
`;

const DownloadComment = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  margin: 11px 0 32px 0;
`;

const UPLOAD_STATE = {
  UPLOADING: 'UPLOADING',
  UPLOADINGSUCCESS: 'UPLOADINGSUCCESS',
  UPLOADINGFAIL: 'UPLOADINGFAIL'
};

export default function NaverWorksUploadFileDialog({
  isShow,
  driveType,
  driveId,
  folderId,
  fileId
}) {
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [uploadState, setUploadState] = useState({
    state: UPLOAD_STATE.UPLOADING,
    iCon: IconSpinner,
    message: t('NaverWorksUploadDialog.Uploading')
  });
  const poSDKContextState = usePOWebofficeSDKState();
  const docInfoSlice = useDocInfoSliceSelector();
  const onClickCloseBtn = () => {
    dispatch(closeDialog());
  };

  const sendGAData = (format) => {
    try {
      let label = `${format}`;
      switch (format.toLowerCase()) {
        case DOCUMENT_TYPE.HWP:
          label = '한글';
          break;
        case DOCUMENT_TYPE.SHEET:
        case DOCUMENT_TYPE.CSV:
          label = '시트';
          break;
        case DOCUMENT_TYPE.SLIDE:
          label = '슬라이드';
          break;
        case DOCUMENT_TYPE.WORD:
          label = '워드';
          break;
        default:
          break;
      }
      ga.event({ category: '웍스드라이브', action: '업로드', label });
    } catch (error) {
      ga.event({ category: '웍스드라이브', action: '업로드', label: `${format}` });
    }
  };

  const onClickUploadNaverWorksFile = async (driveType, driveId, folderId, fileId) => {
    try {
      setUploadState({
        state: UPLOAD_STATE.UPLOADING,
        iCon: IconSpinner,
        message: t('NaverWorksUploadDialog.Uploading')
      });

      let fileName = docInfoSlice.fileName;
      const res = await poSDKContextState.poInstance.handle.saveDocument();
      const file = new File([res.blob], fileName, { type: res.blob.type });

      const reqFolderId = folderId || NAVERWORKS_ROOT_FOLDER_NAME;
      const result = await updateNaverWorksFile({
        file,
        driveType,
        driveId,
        folderId: reqFolderId,
        isLocal: !folderId
      });

      const naverWorksFileInfo = {
        driveType,
        driveId,
        folderId,
        fileId: result?.data?.fileId || ''
      };

      if (result.data.fileName) {
        fileName = result.data.fileName;
        dispatch(setFileName(result.data.fileName));
      }

      dispatch(setNaverWorksFileInfo(naverWorksFileInfo));
      await saveFile({
        state: indexedDBState,
        dispatch: indexedDBDispatch,
        file: new File([res.blob], fileName, { type: res.blob.type }),
        isNaverWorksFile: true,
        naverWorksFileInfo: naverWorksFileInfo
      });

      setUploadState({
        state: UPLOAD_STATE.UPLOADINGSUCCESS,
        iCon: IconCheck,
        message: t('NaverWorksUploadDialog.UploadSuccess')
      });

      sendGAData(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType);
    } catch (error) {
      setUploadState({
        state: UPLOAD_STATE.UPLOADINGSUCCESS,
        iCon: IconFail,
        message: `${t('NaverWorksUploadDialog.UploadFail')} (${error.code || ''})`
      });
    }
  };

  useEffect(() => {
    onClickUploadNaverWorksFile(driveType, driveId, folderId, fileId);
  }, []);

  return (
    <Dialog
      title=""
      showCloseBtn={uploadState.state !== UPLOAD_STATE.UPLOADING}
      showTitleSeperateLine={false}
      onClickCloseBtn={onClickCloseBtn}
      isShow={isShow}>
      <DialogBody>
        <DownloadStateIcon src={uploadState.iCon} />
        <DownloadComment>{uploadState.message}</DownloadComment>
      </DialogBody>
    </Dialog>
  );
}
